import axios from "axios";
import { baseURL } from "./init.js";
 async function fetchEvents(token) {
  
  try {
    const response = await axios.get(`${baseURL}/events`,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
     return response.data.events || [];
  } catch (error) {
     return [];
  }
}

 async function fetchanEvents(id) {
  try {
    const response = await axios.get(`${baseURL}/events/${id}`);
     return response.data.event || {};
  } catch (error) {
     return [];
  }
}

async function createEvent(eventData,userid) {
  try {
    const response = await axios.post(`${baseURL}/events/add/${userid}`, eventData);
    return response.data;
  } catch (error) {
    throw error;
  }
}

async function updateEvent(eventData) {
  try {
    const response = await axios.put(`${baseURL}/events`, eventData);
    return response.data;
  } catch (error) {
    throw error;
  }
}

async function removeEvent(id) {
  try {
    const response = await axios.delete(`${baseURL}/events/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

async function uploadNewEventImg(fd, id) {
  try {
    const response = await axios.post(`${baseURL}/events/upload/${id}`, fd);
    return response.data;
  } catch (error) {
    throw error;
  }
}

async function createEventPrice(eventData,userid) {
  try {
    console.log(eventData);
    
    const response = await axios.post(`${baseURL}/events/price/${userid}`, eventData);
    return response.data;
  } catch (error) {
    // Return backend error payload when available so callers can handle it
    if (error.response && error.response.data) return error.response.data;
    return { state: 'error', message: error.message || 'Request failed' };
  }
}
async function removeEventPrice(pid, eventid) {
  try {
    const response = await axios.delete(`${baseURL}/events/${eventid}/price/${pid}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export { fetchEvents,removeEventPrice, createEvent,createEventPrice,uploadNewEventImg, updateEvent, removeEvent ,fetchanEvents};